import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

import {
  computed, onBeforeMount, onBeforeUnmount, ref, onMounted,
} from 'vue';
import { useStore } from 'vuex';
import FooterSub from '@/components/footer/FooterSub.vue';
import FooterBadge from '@/components/footer/FooterBadge.vue';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore();
const root = ref<InstanceType<typeof HTMLElement>>();
const currentPageType = computed(() => store.getters['page/pageType']);
const hideFooterMain = computed(() => currentPageType.value === 'order');

onBeforeMount(() => {
  store.dispatch('menus/fetchBySlug', 'footer');
  store.dispatch('menus/fetchBySlug', 'footer-sub');
});

const menuSub = computed(() => store.getters['menus/menu']('footer-sub'));

const checkFooterPosition = () => {
  if (root.value) {
    root.value.style.paddingTop = '';
    const position = root.value?.getBoundingClientRect();
    const footerOffset = window.innerHeight - position.bottom;

    if (footerOffset > 0) {
      root.value.style.paddingTop = `${footerOffset}px`;
    }
  }
};

onMounted(() => {
  window.addEventListener('load', checkFooterPosition);
  window.addEventListener('fetched', checkFooterPosition);
  window.addEventListener('resize', checkFooterPosition);
  checkFooterPosition();
});

onBeforeUnmount(() => {
  window.removeEventListener('load', checkFooterPosition);
  window.removeEventListener('fetched', checkFooterPosition);
  window.removeEventListener('resize', checkFooterPosition);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("footer", {
    ref: (_value, _refs) => {
      _refs['root'] = _value
      root.value = _value
    },
    class: "d-print-none"
  }, [
    (!_unref(hideFooterMain))
      ? (_openBlock(), _createBlock(FooterBadge, { key: 0 }))
      : _createCommentVNode("", true),
    _createVNode(FooterSub, {
      items: _unref(menuSub) || []
    }, null, 8, ["items"])
  ], 512))
}
}

})